import { relations } from 'drizzle-orm'
import { date, index, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

export const absenceTypeEnum = pgEnum('absence_type', [
  'sick',
  'child_sick',
  'vacation',
  'paid_leave',
  'unpaid_leave',
  'parental_leave',
  'other',
])

export const absenceStatusEnum = pgEnum('absence_status', [
  'pending',
  'approved',
  'rejected',
])

export const absences = pgTable(
  'absences',
  {
    ...getBaseFields(),
    userId: getIdReference(() => users.id),
    type: absenceTypeEnum().notNull(),
    startDate: date().notNull(),
    endDate: date().notNull(),
    reason: text(),
    status: absenceStatusEnum().notNull().default('pending'),
    approvedByUserId: getNullableIdReference(() => users.id),
    approvedAt: getTimestampWithTimezone(),
    rejectionReason: text(),
    internalNotes: text(),
  },
  (table) => [
    ...getBaseIndexes('absences', table),
    index('absences_user_start_idx').on(table.userId, table.startDate),
    index('absences_status_idx').on(table.status),
  ],
)

export const absencesRelations = relations(absences, ({ one }) => ({
  user: one(users, {
    fields: [absences.userId],
    references: [users.id],
    relationName: 'absenceUser',
  }),
  approvedByUser: one(users, {
    fields: [absences.approvedByUserId],
    references: [users.id],
    relationName: 'absenceApprover',
  }),
}))
